import veritoneApi from './veritoneApi';
import { stringifyWithNoQuoteOnProperties } from '../helpers/formatData';
import { get } from 'lodash';

export const assetPlayoutError = 'playout-errors';
export const assetWebError = 'web-logs-errors';
export const assetPlayoutLogs = 'playout-logs';
export const assetWebLogs = 'web-logs';

export function saveMappingDataApi(urlApi, dataMappingPayload) {
  return veritoneApi(urlApi.baseUrl)
  .post(`/playout`, dataMappingPayload)
  .then(response => response.data)
  .catch(error => ({
    error: true,
    ...error
  }));
}

export function getPlayoutOverviewApi(urlApi, range = {}, fileTypes = []) {
  const { start, end } = range;
  let queryString = `/playout?startDate=${start}&endDate=${end}`;
  if (fileTypes.length === 1){ // get filtered data by a type, else get all playout data
    queryString = queryString.concat(`&fileType=${fileTypes[0]}`)
  }
  return veritoneApi(urlApi.baseUrl)
  .get(queryString)
  .then(response => response.data)
  .catch(error => ({
    error: true,
    ...error
  }));
}

export function getPlayoutSettingApi(urlApi) {
  return veritoneApi(urlApi.baseUrl)
  .get(`/playout/settings`)
  .then(response => response.data)
  .catch(error => ({
    error: true,
    ...error
  }));
}

export function savePlayoutSettingApi(urlApi, settings) {
  return veritoneApi(urlApi.baseUrl)
  .post(`/playout/settings`, settings)
  .then(response => response.data)
  .catch(error => ({
    error: true,
    ...error
  }));
}

export function updateImportStatusApi(urlApi, statusInfo) {
  return veritoneApi(urlApi.baseUrl)
  .post(`/playout/status`, statusInfo)
  .then(response => response.data)
  .catch(error => ({
    error: true,
    ...error
  }));
}

function genCreateAdapterJobQuery(
  routes,
  clusterId,
  tasks
){
  return `
  mutation createGeneralPlayoutAdapterJob {
    createJob(
      input: {
        routes: ${JSON.stringify(routes)},
        clusterId: "${clusterId}",
        tasks: ${stringifyWithNoQuoteOnProperties(tasks)}
      }
    ) {
      id
    }
  }
  `
}

export function createAdapterJobApi(urlApi, routes, clusterId, tasks) {
  return veritoneApi(urlApi.graphql)
  .post(
      '',
      { query: genCreateAdapterJobQuery(routes, clusterId, tasks) }
  )
  .then(response => {
    const id = get(
      response,
      'data.data.createJob.id',
      null
      )
    return ({ id });
  })
  .catch(error => {
    return ({
      error: true,
      ...error
  })})
}

function genGetUriErrorQuery(TDOId) { 
  return `{
        temporalDataObject(id:${TDOId}){
           assets{
              records{
                 assetType
                 signedUri
              }
           }
        }
     }`;
};

export function getSingedUriFromTDOId(urlApi, TDOId) {
  return veritoneApi(urlApi.graphql)
    .post(
      '',
      { query: genGetUriErrorQuery(TDOId) }
    )
    .then(response => {
      const records = get(
        response,
        'data.data.temporalDataObject.assets.records',
        null
      )
      return ({ records });
    }
    )
    .catch(error => ({
      error: true,
      ...error
    }))
}

export function runPlayoutUploadIngestion(urlApi, ingestionData) {
  return veritoneApi(urlApi.baseUrl)
  .post(`/playout/ingestion`, ingestionData)
  .then(response => response.data)
  .catch(error => ({
    error: true,
    ...error
  })); 
}
